import React, {Suspense, useEffect} from 'react';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import {Route, Routes, useNavigate} from "react-router-dom";
import {useIntl} from "react-intl";
import {Circles} from "react-preloaders2";
import {configureApp} from "./lib/config";
import {useUserInfo} from "./lib/hooks/useUserInfo";
import {AuthResponse} from "./lib/services/appointment-service";
import {AdminGuard} from "./lib/AdminGuard"
import useSWR from "swr";
import Preloader from "./Preloader";

const AdminLayout = React.lazy(() => import("./lib/layouts/AdminLayout/AdminLayout"));
const AdminDashboard = React.lazy(() => import("./lib/components/Admin/adminDashboard/AdminDashboard"));
const AdminAppointments = React.lazy(() => import("./lib/components/Admin/adminAppointments/Appointments"));
const AdminMassages = React.lazy(() => import("./lib/components/Admin/adminMassages/AdminMassages"));
const AdminTimeSlots = React.lazy(() => import("./lib/components/Admin/adminTimeSlots/AdminTimeSlots"));
const AdminUsers = React.lazy(() => import("./lib/components/Admin/adminUsers/AdminUsers"));
const Login = React.lazy(() => import("./lib/components/Auth/Login"));
const UserLayout = React.lazy(() => import("./lib/layouts/UserLayout/UserLayout"));
const UserAppointments = React.lazy(() => import("./lib/components/User/UserAppointments"));
const UserCalendar = React.lazy(() => import("./lib/components/User/userCalendar/UserCalendar"));
const UserProfile = React.lazy(() => import("./lib/components/User/userProfile/UserProfile"));
const Register = React.lazy(() => import("./lib/components/Auth/register/Register"));
const MobileAppointments = React.lazy(() => import("./lib/components/Admin/adminMobileAppointments/MobileAppointments"));
const AdminBlockedDates = React.lazy(() => import("./lib/components/Admin/adminBlockedDates/AdminBlockedDates"));
const RequestNewPassword = React.lazy(() => import("./lib/components/Auth/resetPassword/requestNewPassword/RequestNewPassword"));
const ResetPassword = React.lazy(() => import("./lib/components/Auth/resetPassword/ResetPassword"));

interface Props {

}

const App: React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const navigate = useNavigate();

    const {userInfo, updateUserInfo} = useUserInfo();
    const {
        data: userData,
        error: checkIfAuthenticatedError
    } = useSWR<AuthResponse, Error>("api/auth/checkIfAuthenticated");
    configureApp(f);

    useEffect(() => {
        if (userData) {
            updateUserInfo({
                ...userData,
                authenticated: true,
                role: userData.role,
                id: userData.id
            });

        }
    }, [userData]);


    if (!userInfo) {
        return <Preloader/>
    }


    return <>
        <Suspense fallback={<Preloader/>}>
            <Routes>
                {!userInfo.authenticated ? (
                    <>
                        <Route path="*" element={<Login/>}/>
                        <Route path="/register" element={<Register/>}/>
                        <Route path="/reset-password" element={<ResetPassword/>}/>
                        <Route path="/request-new-password" element={<RequestNewPassword/>}/>
                    </>
                ) : (
                    <>
                        <Route path="/admin/*" element={<AdminGuard><AdminLayout/></AdminGuard>}>
                            <Route index element={<AdminDashboard/>}/>
                            <Route path="appointments" element={<AdminAppointments/>}/>
                            <Route path="blocked-dates" element={<AdminBlockedDates/>}/>
                            <Route path="appointments-list" element={<MobileAppointments/>}/>
                            <Route path="massages" element={<AdminMassages/>}/>
                            <Route path="time-slots" element={<AdminTimeSlots/>}/>
                            <Route path="users" element={<AdminUsers/>}/>
                        </Route>

                        <Route path="/" element={<UserLayout/>}>
                            <Route index element={<UserCalendar/>}/>
                            <Route path="my-appointments" element={<UserAppointments/>}/>
                            <Route path="profile" element={<UserProfile/>}/>
                        </Route>
                    </>
                )}
            </Routes>
        </Suspense>
    </>

};

export default App;
